import AddressFinder from './AddressFinder';

export default AddressFinder;
